import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { siteInfo, navLinks } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md py-4'
          : 'bg-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
            <span className={`text-2xl font-light tracking-tight transition-colors duration-300 ${
              isScrolled ? 'text-[#1a1a1a]' : 'text-white'
            }`} style={{ fontFamily: 'Playfair Display, serif' }}>
              Les Terres de Songon
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                data-testid={`nav-link-${link.href.replace('/', '') || 'home'}`}
                className={`text-sm font-medium tracking-wide transition-all duration-300 underline-effect ${
                  location.pathname === link.href 
                    ? (isScrolled ? 'text-[#1a1a1a]' : 'text-white')
                    : (isScrolled ? 'text-[#666]' : 'text-white/80')
                } hover:${isScrolled ? 'text-[#1a1a1a]' : 'text-white'}`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <div className="hidden lg:flex items-center">
            <Link to="/contact">
              <button 
                data-testid="header-contact-btn"
                className={`px-6 py-2.5 text-sm font-medium tracking-wide transition-all duration-300 rounded-none ${
                  isScrolled 
                    ? 'bg-[#1a1a1a] text-white hover:bg-[#333]' 
                    : 'bg-white text-[#1a1a1a] hover:bg-white/90'
                }`}
              >
                Nous contacter
              </button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {isMobileMenuOpen ? (
              <X className={isScrolled ? 'text-[#1a1a1a]' : 'text-white'} size={24} />
            ) : (
              <Menu className={isScrolled ? 'text-[#1a1a1a]' : 'text-white'} size={24} />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-6 pb-6 border-t border-white/20" data-testid="mobile-menu">
            <nav className="flex flex-col gap-4 pt-6">
              {navLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.href}
                  className={`text-sm font-medium ${
                    isScrolled ? 'text-[#1a1a1a]' : 'text-white'
                  }`}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
                <button className="mt-4 w-full bg-[#1a1a1a] text-white py-3 text-sm font-medium">
                  Nous contacter
                </button>
              </Link>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
